import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { protectedRoutes } from "Routes/protectedRoutes";
import { authRoutes } from "Routes/unProtectedRoutes";
import { ConfigProvider, App as AntdApp } from "antd";
import { ANT_BREAKPOINTS } from "@utils/theme";
import { store } from "./store";

const router = createBrowserRouter([...protectedRoutes, ...authRoutes]);

const root = ReactDOM.createRoot(document.getElementById("root"));


root.render(
  <React.StrictMode>
      <Provider store={store}>
        <ConfigProvider
          wave={{ disabled: true }}
          theme={{
            token: ANT_BREAKPOINTS,
          }}
        >
          <AntdApp>
            <RouterProvider router={router} />
          </AntdApp>
        </ConfigProvider>
      </Provider>
  </React.StrictMode>
);
